import {
  organizationManagementApiV1 as organizationManagementApi,
  timestampApi,
} from '@deepup/apis';

export enum OrderNumberType {
  SMA = 'SMA',
}

export enum OrderNumberSubType {
  APL = 'APL',
  HK = 'HK',
  NVT = 'NVT',
}

export interface OrderNumber {
  type: OrderNumberType;
  value: string;
  subType?: OrderNumberSubType;
  networkNodeMappings?: organizationManagementApi.NetworkNodeMapping[];
  allowInheritance?: boolean;
  closedAt?: timestampApi.Timestamp | string | Date | null;
  closedInExternalSystem?: boolean;
}

export function isOrderNumberClosed(
  orderNumber?: {
    closedAt?: timestampApi.Timestamp | string | Date | null;
    closedInExternalSystem?: boolean;
  } | null,
): boolean {
  if (!orderNumber) return false;
  return Boolean(orderNumber.closedAt || orderNumber.closedInExternalSystem);
}

export function mapNetworkNodeTypeToOrderNumberSubType(
  type?: organizationManagementApi.NetworkNodeType,
): OrderNumberSubType | undefined {
  if (type === undefined || type === null) {
    return undefined;
  }

  switch (type) {
    case organizationManagementApi.NetworkNodeType.APL:
      return OrderNumberSubType.APL;
    case organizationManagementApi.NetworkNodeType.HK:
      return OrderNumberSubType.HK;
    case organizationManagementApi.NetworkNodeType.NVT:
      return OrderNumberSubType.NVT;
    case organizationManagementApi.NetworkNodeType.POP:
    case organizationManagementApi.NetworkNodeType.BB:
    case organizationManagementApi.NetworkNodeType.UNSPECIFIED:
    default:
      return undefined;
  }
}
